const datos = {}
datos.server = 'https://back.delpasystem.com/api/2.0'
datos.server_debug = 'https://back.delpasystem.com/api/staging/2.0'
module.exports = datos